import { EVENT_LOCATIONS, NAVIGATION_FROM_LOCATIONS } from './constants'

/**
 * Maps event location to navigation from location for tracking purposes
 * @param {string} eventLocation - The event location from EVENT_LOCATIONS
 * @returns {string} The corresponding navigation from location
 */
export const mapEventLocationToNavigationFromLocation = (eventLocation) => {
  switch (eventLocation) {
    case EVENT_LOCATIONS.BURGER_MENU:
      return NAVIGATION_FROM_LOCATIONS.BURGER_NAV
    case EVENT_LOCATIONS.HEADER:
      return NAVIGATION_FROM_LOCATIONS.HEADER_NAV
    default:
      return ''
  }
}
